module.exports = __webpack_public_path__ + "img/course_cs73.294716f7.png";